import { css } from '@compiled/react';

export type CustomCheckboxProps = {
	checked: boolean;
	onChange: () => void;
};

/**
 * Custom checkbox that replaces Atlaskit Checkbox with a design-approved version.
 * Renders a 24px square button with a checkmark when checked.
 * This component is decorative only (aria-hidden) - the parent ChoiceCard handles accessibility.
 */
export const CustomCheckbox = ({ checked, onChange }: CustomCheckboxProps) => {
	return (
		<label css={labelStyles} aria-hidden="true">
			<input
				type="checkbox"
				checked={checked}
				onChange={onChange}
				tabIndex={-1}
				css={hiddenInputStyles}
			/>
			<span css={checkboxVisualStyles}>
				{checked ? (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M3.375 0C1.51104 0 0 1.51104 0 3.375V20.25C0 22.114 1.51104 23.625 3.375 23.625H20.25C22.114 23.625 23.625 22.114 23.625 20.25V3.375C23.625 1.51104 22.114 0 20.25 0H3.375ZM19.1129 7.56023L17.1683 5.93977L9.70312 14.898L6.45666 11.0023L4.51209 12.6227L8.73084 17.6852C8.97131 17.9738 9.32751 18.1406 9.70312 18.1406C10.0787 18.1406 10.4349 17.9738 10.6754 17.6852L19.1129 7.56023Z"
							fill="#1868DB"
						/>
					</svg>
				) : (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<rect
							x="0.5"
							y="0.5"
							width="23"
							height="23"
							rx="2"
							fill="none"
							stroke="#8C8F97"
							strokeWidth="1"
						/>
					</svg>
				)}
			</span>
		</label>
	);
};

const labelStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	cursor: 'pointer',
	position: 'relative',
});

const hiddenInputStyles = css({
	position: 'absolute',
	opacity: 0,
	width: 0,
	height: 0,
	margin: 0,
	padding: 0,
});

const checkboxVisualStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 24,
	height: 24,
	flexShrink: 0,
});
